import * as React from 'react';
const SVGComponent = (props) => (
  <svg
    width={39}
    height={49}
    viewBox='0 0 39 49'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19.51 23.77q1.808 0 3.086-1.287 1.28-1.288 1.28-3.096t-1.29-3.088q-1.287-1.278-3.095-1.278t-3.087 1.288-1.28 3.096 1.29 3.087q1.287 1.28 3.095 1.279m-.01 21.522q7.636-6.646 12.073-13.519 4.438-6.872 4.438-11.887 0-7.433-4.706-12.27Q26.599 2.782 19.5 2.782T7.695 7.618 2.99 19.886q0 5.015 4.438 11.887T19.5 45.292m0 3.635Q9.953 40.485 5.117 33.18T.281 19.886q0-8.595 5.597-14.178Q11.473.125 19.5.125q8.026 0 13.622 5.583 5.597 5.583 5.597 14.178 0 5.99-4.836 13.293-4.836 7.306-14.383 15.748'
      fill='#E4E4F9'
    />
  </svg>
);
export default SVGComponent;
